import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { resolvedDataNeededQueryKey } from "../decisioning.keys";

export const useFetchResolvedDataNeeded = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: resolvedDataNeededQueryKey(accountId),
		meta: { suppressErrorModal: true },
		queryFn: async () =>
			Dtos.Decisioning.DataNeeded.Get.Response.schema
				.array()
				.parse(await get<unknown>(`/v2/admin/surety/accounts/${accountId}/data-needed/resolved`)),
	});

	return {
		resolvedDataNeeded: query.data,
		resolvedDataNeededIsLoading: query.isLoading,
		resolvedDataNeededError: query.error,
		refetchResolvedDataNeeded: query.refetch,
	};
};
